export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1773236376162-14b9c09b28f4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGZpbmFuY2UlMjBsdXh1cnl8ZW58MHx8fHwxNzg0NTcxNDAzfDA&ixlib=rb-4.1.0&q=85",
  familyOffices: "https://images.unsplash.com/photo-1764810815228-b7f9432eec5c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxleGVjdXRpdmUlMjBib2FyZHJvb218ZW58MHx8fHwxNzg0NTcxNDAzfDA&ixlib=rb-4.1.0&q=85",
  capital: "https://images.unsplash.com/photo-1605001062746-4548791acc99?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBza3lzY3JhcGVyJTIwYXJjaGl0ZWN0dXJlJTIwZ29sZGVuJTIwaG91cnxlbnwwfHx8fDE3ODQ1NzE1MDV8MA&ixlib=rb-4.1.0&q=85",
  realEstate: "https://images.unsplash.com/photo-1525286376485-60c84ee403d1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjBkZXRhaWx8ZW58MHx8fHwxNzg0NTcxNDA0fDA&ixlib=rb-4.1.0&q=85",
  consulting: "https://images.pexels.com/photos/5778469/pexels-photo-5778469.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  global: "https://images.pexels.com/photos/11001427/pexels-photo-11001427.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const SERVICES = [
  {
    n: "01",
    title: "Family Offices & Investor Relations",
    tag: "Private Wealth",
    body: "Unrivalled access to Ultra-High-Net-Worth individuals and the largest family office and private wealth network worldwide — matched with precision to your mandate.",
    img: IMAGES.familyOffices,
    span: "lg:col-span-3 lg:row-span-2",
  },
  {
    n: "02",
    title: "Capital Raising",
    tag: "Equity & Debt",
    body: "End-to-end capital formation — equity and debt, primary and secondary — for operating companies and private investment funds, from strategy through close.",
    img: IMAGES.capital,
    span: "lg:col-span-2",
  },
  {
    n: "03",
    title: "M&A Advisory",
    tag: "Sell-side & Buy-side",
    body: "Acquisitions, divestitures and mergers advised with institutional rigour to maximise value and outcomes on both sides of every transaction.",
    img: IMAGES.realEstate,
    span: "lg:col-span-2",
  },
  {
    n: "04",
    title: "Impact Investing",
    tag: "ClimateTech & Green Energy",
    body: "Curated impact investment opportunities across ClimateTech and green energy — capital that compounds returns and measurable change.",
    img: IMAGES.consulting,
    span: "lg:col-span-2",
  },
];

export const PROCESS = [
  { n: "01", title: "Discover", body: "We understand your business, your vision, your market and your competitive advantage before anything else." },
  { n: "02", title: "Prepare", body: "Investment readiness, financial storytelling, financial strategy and precise investor positioning." },
  { n: "03", title: "Connect", body: "We introduce the right investors — not simply the most investors. Alignment always comes before volume." },
  { n: "04", title: "Execute", body: "Negotiate. Structure. Close. Support. We are an extension of your executive team through the deal." },
  { n: "05", title: "Grow", body: "We continue advising after funding — because long-term relationships create long-term value." },
];

export const STATS = [
  "$500M+ Capital Raised",
  "$50B+ Platform Deal Volume",
  "2,000+ Transactions",
  "300+ Investment Bankers",
  "Ultra-HNW & Family Office Access",
  "Where Capital Meets Consciousness",
];

export const CENTERS = [
  "New York", "London", "Tel Aviv", "Zurich", "Singapore", "Dubai", "Hong Kong", "Geneva",
];

export const TRACK = [
  { value: "$500M+", label: "Capital Raised in Private Markets" },
  { value: "$50B+", label: "Platform Deal Volume" },
  { value: "2,000+", label: "Transactions Completed" },
  { value: "300+", label: "Investment Bankers" },
];

export const DEALS = [
  { company: "Inworks", detail: "Acquired by Paymerang", sector: "FinTech · M&A" },
  { company: "Super73", detail: "Growth capital raise", sector: "Electric Mobility · ClimateTech" },
  { company: "Blue Whale Materials", detail: "Battery recycling capital", sector: "ClimateTech" },
  { company: "BlackBerry", detail: "Advisory transaction", sector: "Technology" },
  { company: "Soberlink", detail: "Capital raise", sector: "HealthTech" },
  { company: "Oxford", detail: "Strategic transaction", sector: "Financial Services" },
];


export const PILLARS = [
  {
    n: "01",
    title: "Investment Banking",
    body: "We advise private companies through every stage of growth.",
    items: ["Growth Capital", "Series A–D Financing", "Late-Stage Financing", "Private Placements", "Strategic Capital Partnerships"],
  },
  {
    n: "02",
    title: "M&A Advisory",
    body: "Maximising value and outcomes on both sides of the table.",
    items: ["Sell-Side Advisory", "Buy-Side Advisory", "Strategic Introductions", "Corporate Development", "Capital Strategy"],
  },
  {
    n: "03",
    title: "Capital Raising",
    body: "We prepare companies to raise institutional capital.",
    items: ["Investment Readiness", "Financial Storytelling", "Investor Deck & Modeling", "Valuation Strategy", "Due Diligence & Data Room", "Investor Targeting", "Roadshows", "Negotiation & Closing"],
  },
  {
    n: "04",
    title: "Investor Relations",
    body: "Capital raising doesn't end after funding. We build long-term investor confidence.",
    items: ["Investor Communications", "Shareholder Strategy", "Executive Positioning", "Quarterly Updates", "Capital Markets Advisory", "Long-Term Relationship Management"],
  },
  {
    n: "05",
    title: "Family Office Advisory",
    body: "Differentiated private-market opportunities for sophisticated investors.",
    items: ["AI & Enterprise Software", "Healthcare & Biotech", "Fintech & Infrastructure", "Climate Technology & Energy", "Private Equity & Venture", "Real Estate & Private Credit"],
  },
  {
    n: "06",
    title: "Strategic Advisory",
    body: "Sometimes companies don't need capital. They need clarity.",
    items: ["Growth Strategy", "Executive Decision Making", "Market Positioning", "Strategic Partnerships", "Go-to-Market Strategy", "Board Advisory"],
  },
];

export const INDUSTRIES = [
  { group: "Technology", items: ["Artificial Intelligence", "Machine Learning", "Cybersecurity", "Cloud Infrastructure", "Enterprise Software", "Semiconductors"] },
  { group: "Healthcare", items: ["Medical Devices", "Diagnostics", "Digital Health", "Biotechnology", "Life Sciences", "Healthcare AI"] },
  { group: "Financial Services", items: ["FinTech", "Payments", "Digital Assets", "Alternative Investments", "Private Markets"] },
  { group: "Sustainability", items: ["Climate Technology", "Agriculture & Food Tech", "Energy Transition", "Water Technologies", "Carbon Solutions"] },
  { group: "Real Estate", items: ["Multifamily", "Hospitality", "Industrial", "Mixed Use"] },
  { group: "Private Credit", items: ["Bridge Financing", "Development Capital"] },
  { group: "Deep Tech & Defense", items: ["Quantum Computing", "Robotics", "Physical AI", "Aerospace", "Defense"] },
];

export const VALUES = [
  { t: "Integrity First", d: "Trust is earned." },
  { t: "Relationships Before Transactions", d: "Long-term partnerships outperform short-term deals." },
  { t: "Excellence", d: "Every interaction reflects our standards." },
  { t: "Purpose", d: "Capital should improve lives." },
  { t: "Innovation", d: "The future belongs to visionary builders." },
  { t: "Legacy", d: "Success is measured by the value we leave behind." },
];

export const CLIENTS = [
  { title: "Founders", body: "Growth-stage companies raising between $5M and $100M." },
  { title: "Family Offices", body: "Seeking differentiated private investments with long-term value creation." },
  { title: "Institutional Investors", body: "Private equity, venture capital, private credit and strategic investors." },
  { title: "Entrepreneurs", body: "Building businesses capable of changing industries." },
];
